// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"9920":"b3562ad0673f5dc2","21358":"a8b025647d00e2ee","24942":"1bb84b9483dabb29","61057":"133c4b0ec1456050","94336":"e4662032acdfe9fa"}[chunkId] + ".css";
};